export default "__VITE_ASSET__D09Pk8IC__"